import React from 'react';
import { Col, ControlLabel, FormGroup, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { FormError } from '../../../FormError.jsx';
import GroupsBulkSelect from '../../../GroupsBulkSelect.jsx';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import FormStepsNav from './FormStepsNav.jsx';
import CurrentCSVDownloadButton from '../CurrentCSVDownloadButton.jsx';
import CustomRadio from '../../../CustomRadio.jsx';

import { getOrgTermsContent } from '../../../../content/utils.js';
import ImpactedGroups from '../../../group-form-field/SelectedGroups.jsx';
import EmployeesField from '../../../EmployeesField.jsx';
import AuthorizedAction from '../../../AuthorizedAction.js';

export const groupsUploadMethodOptions = [
  { label: 'Add Manually', value: 'manually' },
  { label: 'Bulk CSV Upload', value: 'csv' },
];

export const replaceOptions = [
  { label: 'Add new participant to an existing structure', value: 'add' },
  { label: 'Replace existing structure', value: 'replace' },
];

function StepGroupParticipantsManuallyForm({
  handleSubmit,
  formRef,
  submitError,
  submitFailed,
  submitting,
  onShowGroupModal,
  editing,
  entities,
  uploadMethod,
  setUploadMethod,
  replaceMethod,
  setReplaceMethod,
  onDownloadCsv,
  stakeholderDraft,
  onCancel,
  onBack,
  values,
  participantsEditAllowed,
  onSelectGroup,
  onShowManageGroupModal,
  onSelectUngroupedEmployee,
  onShowManageParticipantsModal,
  ungroupedSearchParams,
}) {
  const { groups, ungroupedEmployees } = entities;

  return (
    <form ref={formRef}>
      <Row>
        <FormStepsNav activeIndex={2} onSubmit={handleSubmit} onBack={onBack} />
      </Row>

      {participantsEditAllowed ? (
        <React.Fragment>
          <Row>
            <Col xs={6}>
              <p className="text-muted m-b-32">
                If needed, select a organization-wide group(s) that forms part
                of this Stakeholder profile. For example: Human Resources.
              </p>
            </Col>
            <Col xs={12}>
              <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
                <h3>Add People</h3>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <p className="text-muted m-b-24">
                Upload a CSV or add Group(s) manually.
              </p>
              <div className="m-b-18">
                <CustomRadio
                  name="uploadMethod"
                  checkedValue={uploadMethod}
                  options={groupsUploadMethodOptions}
                  action={setUploadMethod}
                />
              </div>
            </Col>
          </Row>

          {uploadMethod === 'csv' ? (
            <Row className="m-b-24">
              <Col xs={6}>
                <div className="m-b-12">
                  <CustomRadio
                    name="replaceMethod"
                    checkedValue={replaceMethod}
                    options={replaceOptions}
                    action={setReplaceMethod}
                  />
                </div>
              </Col>
              {editing && stakeholderDraft?.groups_data ? (
                <Col xs={12}>
                  <CurrentCSVDownloadButton onDownloadCsv={onDownloadCsv} />
                </Col>
              ) : null}
            </Row>
          ) : null}

          <Row>
            <Col xs={8}>
              <FormGroup>
                <ControlLabel className="flex flex-justify">
                  <div>
                    Add Group(s)
                    <strong className="bordered bordered-xs text-muted m-l-8">
                      Total:&nbsp;
                      <span className="text-info-brand count">
                        {Object.keys(groups).length}
                      </span>
                    </strong>
                  </div>
                  <AuthorizedAction action="create" subject="group">
                    <button
                      type="button"
                      className="btn-clear btn-link"
                      onClick={onShowGroupModal}
                    >
                      + Add Group
                    </button>
                  </AuthorizedAction>
                </ControlLabel>
                <GroupsBulkSelect
                  selected={groups}
                  handleSelect={onSelectGroup}
                  onShowGroupModal={onShowGroupModal}
                  showArchived={editing}
                  customClass="m-0"
                />
              </FormGroup>
            </Col>
            <Col xs={8}>
              <ImpactedGroups
                selected={groups}
                handleSelect={onSelectGroup}
                onShowManageModal={onShowManageGroupModal}
              />
            </Col>

            <Col xs={8}>
              <div className="m-b-24">
                <Field
                  id="people"
                  name="people"
                  selected={ungroupedEmployees}
                  handleSelect={onSelectUngroupedEmployee}
                  additionalSearchParams={ungroupedSearchParams}
                  onShowManageModal={onShowManageParticipantsModal}
                  title="Select or Add People"
                  component={EmployeesField}
                />
              </div>
            </Col>
          </Row>
          <Row>
            {/* <Col xs={8} className="m-b-32"> */}
            {/*  <AuthorizedAction action="create" subject="employee"> */}
            {/*    <button type="button" className="btn-link" onClick={() => onShowEmployeeModal()}> */}
            {/*      {' '} */}
            {/*      + Add People */}
            {/*    </button> */}
            {/*  </AuthorizedAction> */}
            {/* </Col> */}
          </Row>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Participants</h3>
          </div>
          <p className="text-muted m-b-48">
            It’s not allowed to change stakeholder participants in outdated
            stakeholder profiles. If you want to proceed, please correct{' '}
            {getOrgTermsContent('project')} dates first.
          </p>
        </React.Fragment>
      )}

      <Row>
        <Col xs={12}>
          {submitFailed && submitError ? (
            <FormError submitError={submitError} />
          ) : null}
        </Col>

        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={submitting}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepGroupParticipantsManuallyForm;
